import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutButtonB2B',
  props: {
    buttonText: null,
    showSpinnerOnButton: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
        buttonText: string,
        showSpinnerOnButton?: boolean,
    }

    

return { __sfc: true,props }
}

})